import { ApiHelper } from 'shared/helpers/api';
import { getUrl, ROUTES } from 'shared/api/urls';
import { transformData } from './transformer';
import { getDomainConfig } from 'shared/domainConfig/helpers';
import { buildStoreRedirectId, getCurrentStoreId } from 'shared/helpers/storeUrl';


export const getMegaMenuV2 = (storeId: string = getCurrentStoreId()): Promise<any> => {
  const { MEGA_MENU_VERSION } = getDomainConfig();
  const isV4 = MEGA_MENU_VERSION === 'V4';
  const urlVersion = isV4 ? ROUTES.MEGA_MENU_V4 : ROUTES.MEGA_MENU_V2;
  const url = getUrl(urlVersion);
  const params = new URLSearchParams(url.split('?')[1] || '');

  if (isV4) {
    params.set('domain', process.env.DOMAIN_NAME || '');
  }
  const catalogTag = buildStoreRedirectId(storeId);
  if (catalogTag) params.set('catalog_tag_filter', catalogTag);

  const categoryUrl = `${url.split('?')[0]}?${params.toString()}`;


  return ApiHelper(`${categoryUrl}`).then(async (response: Response) => {
    try {
      const data = await response.json();
      if (response.ok === false) {
        return Promise.reject({ status: response.status, data });
      }

      return data;
    } catch (e) {
      return Promise.reject({ status: 500 });
    }
  });
};

export const getMenuContent = async (storeId: string): Promise<any> => {
  const data = await getMegaMenuV2(storeId);
  return transformData(data);
};
